<div class="navbar-container">
    @if(isHomePage) {
            <div class="navbar">
                <span style="margin-right: 30px;"></span>
                <img
                [src]="setNavLogo()"
                alt="QBuilt_Logo"
                class="home-logo">

                <button
                class="account-button"
                mat-icon-button
                type="button"
                [matMenuTriggerFor]="menu"
                aria-label="Account button"
                >
                <mat-icon
                    aria-hidden="false"
                    aria-label="User Account"
                    [fontIcon]="icons.account"
                ></mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="toggleSettings('Settings')">
                        Settings
                    </button>
                </mat-menu>
            </div>
    } @else {
        <div class="navbar">
            <button mat-icon-button class="home-button" (click)="goToHomePage()">
                <span class="material-symbols-outlined home-icon">
                    home
                </span>
            </button>
            <img style="height: 96.11px;"
            [src]="setNavLogo()"
            alt="QBuilt_Logo">
            <button
            class="account-button"
            mat-icon-button
            type="button"
            [matMenuTriggerFor]="menu"
            aria-label="Account button"
            >
            <mat-icon
                aria-hidden="false"
                aria-label="User Account"
                [fontIcon]="icons.account"
            ></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="toggleSettings('Settings')">
                    Settings
                </button>
            </mat-menu>
        </div>
    }
</div>